export default __webpack_public_path__ + "static/ita-logo-small-6ab3ae099bae44e7889f80b35def44e1.png";